import axios, { AxiosResponse, AxiosRequestConfig } from "axios";

class ApiService {
  private authToken: string;

  constructor(authToken: string = "") {
    this.authToken = authToken;
  }

  public setAuthToken(token: string) {
    this.authToken = token;
  }

  private async request<T>(config: AxiosRequestConfig): Promise<T | null> {
    try {
      const headers = {
        ...config.headers,
        Authorization: `Bearer ${this.authToken}`,
      };

      const response: AxiosResponse<T> = await axios({
        ...config,
        headers,
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("API call failed:", error.message);
        return error.response?.data || null;
      } else {
        console.error("An unexpected error occurred:", error);
        return null;
      }
    }
  }

  public async get<T>(url: string, params?: any): Promise<T | null> {
    return this.request<T>({
      method: "GET",
      url,
      params: typeof params === "string" ? JSON.parse(params) : params,
    });
  }

  public async post<T>(url: string, data?: any): Promise<T | null> {
    return this.request<T>({
      method: "POST",
      url,
      data: typeof data === "string" ? JSON.parse(data) : data,
    });
  }

  public async put<T>(url: string, data?: object): Promise<T | null> {
    return this.request<T>({
      method: "PUT",
      url,
      data,
    });
  }

  public async delete<T>(url: string): Promise<T | null> {
    return this.request<T>({
      method: "DELETE",
      url,
    });
  }
}

const apiService = new ApiService();
export default apiService;
